<div class="attestation-modal">
  <div class="modal-header">
    <div class="header-content">
      <h2>Promoting Interoperability Attestations</h2>
    </div>
    <button mat-icon-button (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-banner">
    <mat-icon>info</mat-icon>
    <div class="banner-text">
      <p>
        <strong>Required attestations (*) are mandatory</strong> to report measures under the PI category of MIPS.
      </p>
    </div>
  </div>

  <div class="modal-body">
    <div class="attestation-card" [class.answered]="piAudit">
      <div class="card-header">
        <div class="attestation-number">1</div>
        <h3>PI Attestation <span class="required">*</span></h3>
      </div>
      <div class="attestation-statement">
        <div class="statement-text">
          By attesting to this statement, I hereby declare my acceptance to
          support any audit carried out by the registry and also to provide the
          relevant document(s) as per the data validation criteria guidelines
          set by CMS.
        </div>
      </div>
      <div class="answer-section">
        <mat-checkbox [(ngModel)]="piAudit" color="primary">
          I agree to this attestation
        </mat-checkbox>
      </div>
    </div>

    <div class="attestation-card" [class.answered]="oncDirectReview === 'yes'" [class.answered-no]="oncDirectReview === 'no'">
      <div class="card-header">
        <div class="attestation-number">2</div>
        <h3>ONC Direct Review Attestation <span class="required">*</span></h3>
      </div>
      <div class="attestation-statement">
        <p class="statement-label">I Attest that I:</p>
        <div class="statement-text">
          (1) I, Acknowledge the requirement to cooperate in good faith with ONC
          direct review of his or her health information technology certified
          under the ONC Health IT Certification Program if a request to assist
          in ONC direct review is received; and; (2) If requested, cooperated in
          good faith with ONC direct review of his or her health information
          technology certified under the ONC Health IT Certification Program as
          authorized by 45 CFR part 170, subpart E, to the extent that such
          technology meets (or can be used to meet) the definition of CEHRT,
          including by permitting timely access to such technology and
          demonstrating its capabilities as implemented and used by the MIPS
          eligible clinician in the field.
        </div>
      </div>
      <div class="answer-section">
        <mat-radio-group [(ngModel)]="oncDirectReview">
          <mat-radio-button value="yes">Yes</mat-radio-button>
          <mat-radio-button value="no">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="attestation-card" [class.answered]="interoperability === 'yes'" [class.answered-no]="interoperability === 'no'">
      <div class="card-header">
        <div class="attestation-number">3</div>
        <h3>
          Actions to Limit or Restrict Interoperability of CEHRT Attestation
          <span class="required">*</span>
        </h3>
      </div>
      <div class="attestation-statement">
        <p class="statement-label">I attest to CMS that I -</p>
        <div class="statement-text">
          (A) did not knowingly and willfully take action (such as to disable
          functionality) to limit or restrict the compatibility or
          interoperability of certified EHR technology. (B) Implemented
          technologies, standards, policies, practices, and agreements
          reasonably calculated to ensure, to the greatest extent practicable
          and permitted by law, that the certified EHR technology was, at all
          relevant times: • Connected in accordance with applicable law; •
          Compliant with all standards applicable to the exchange of
          information, including the standards, implementation specifications,
          and certification criteria adopted at 45 CFR part 170; • Implemented
          in a manner that allowed for timely access by patients to their
          electronic health information; and • Implemented in a manner that
          allowed for the timely, secure, and trusted bi-directional exchange of
          structured electronic health information with other health care
          providers (as defined by 42 U.S.C. 300jj(3)), including unaffiliated
          health care providers, and with disparate certified EHR technology and
          vendors. (C) Responded in good faith and in a timely manner to
          requests to retrieve or exchange electronic health information,
          including from patients, health care providers (as defined by 42
          U.S.C. 300jj(3)), and other persons, regardless of the requestor's
          affiliation or technology vendor.
        </div>
      </div>
      <div class="answer-section">
        <mat-radio-group [(ngModel)]="interoperability">
          <mat-radio-button value="yes">Yes</mat-radio-button>
          <mat-radio-button value="no">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Security Risk Analysis — single question for 2025, two questions for 2026+ -->
    <div
      class="attestation-card"
      [class.answered]="isYear2026Plus
        ? (securityRiskAnalysis === 'yes' && securityRiskAnalysisImplemented === 'yes')
        : securityRiskAnalysis === 'yes'"
      [class.answered-no]="isYear2026Plus
        ? (securityRiskAnalysis === 'no' || securityRiskAnalysisImplemented === 'no')
        : securityRiskAnalysis === 'no'"
    >
      <div class="card-header">
        <div class="attestation-number">4</div>
        <h3>
          Conduct or Review a Security Risk Analysis
          <span class="required">*</span>
        </h3>
      </div>

      <ng-container *ngIf="!isYear2026Plus">
        <div class="attestation-statement">
          <div class="statement-text">
            Conduct or review a security risk analysis on your CEHRT functionality
            (that meets ONC's health IT certification criteria in 45 CFR 170.315)
            on an annual basis, within the calendar year of the performance
            period. For example, if you have your CEHRT functionality that meets
            ONC's health IT certification criteria in place on January 1, 2025,
            you can perform your security risk assessment on March 1, 2025, and
            select a 180-day performance period of July 5, 2025 – December 31,
            2025. Additional guidance on conducting a security risk analysis is
            available on the webpage Guidance on Risk Analysis | HHS.gov
          </div>
        </div>
        <div class="answer-section">
          <mat-radio-group [(ngModel)]="securityRiskAnalysis">
            <mat-radio-button value="yes">Yes</mat-radio-button>
            <mat-radio-button value="no">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </ng-container>

      <ng-container *ngIf="isYear2026Plus">
        <div class="attestation-statement">
          <div class="statement-text">
            You must complete both components of the Security Risk Analysis
            measure on an annual basis within the calendar year of the
            performance period. A "Yes" response is required for both
            components. A "No" response won't satisfy this measure.
          </div>
        </div>

        <div class="sub-question">
          <p class="sub-question-label">
            1. Conduct or review a security risk analysis on your CEHRT
            functionality (that meets ONC's health IT certification criteria in
            45 CFR 170.315).
          </p>
          <div class="answer-section">
            <mat-radio-group [(ngModel)]="securityRiskAnalysis">
              <mat-radio-button value="yes">Yes</mat-radio-button>
              <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="sub-question">
          <p class="sub-question-label">
            2. Implement security risk management to sufficiently reduce risks
            and vulnerabilities as required under the HIPAA Security Rule (see
            45 CFR 164.308(a)(1)(ii)(B)).
          </p>
          <div class="answer-section">
            <mat-radio-group [(ngModel)]="securityRiskAnalysisImplemented">
              <mat-radio-button value="yes">Yes</mat-radio-button>
              <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="attestation-card" [class.answered]="saferGuides === 'yes'" [class.answered-no]="saferGuides === 'no'">
      <div class="card-header">
        <div class="attestation-number">5</div>
        <h3>
          <ng-container *ngIf="isYear2026Plus">
            Complete an Annual Assessment Using the 2025 High Priority Practices
            SAFER Guide
          </ng-container>
          <ng-container *ngIf="!isYear2026Plus">
            Perform an Annual Assessment of the High Priority Guide (from the
            SAFER Guides)
          </ng-container>
          <span class="required">*</span>
        </h3>
      </div>
      <div class="attestation-statement">
        <div class="statement-text">
          <ng-container *ngIf="isYear2026Plus">
            You must conduct an annual self-assessment within the calendar year
            of the performance period using the 2025 High Priority Practices
            Guide (a part of the 2025 SAFER Guides). To complete the
            self-assessment, you must complete a review and mark the associated
            checkboxes (fully implemented, substantial progress, halfway there,
            making progress, or not implemented) of recommended practices
            located at the beginning of the Guide. Detailed worksheets with the
            rationale, and examples of how to implement each recommended
            practice follow the checklist section of the Guide. These worksheets
            include likely sources of information that your practice may
            reference to complete your assessment of a recommended practice, as
            well as fillable note fields to record follow-up actions. A "Yes"
            response is required. A "No" response won't satisfy this measure.
          </ng-container>
          <ng-container *ngIf="!isYear2026Plus">
            I conducted a self-assessment using the High Priority Practices SAFER
            Guide during the calendar year in which the performance period occurs.
            To complete the self-assessment, you must complete a review and mark
            the associated checkboxes (fully, partially, or not implemented) of
            recommended practices included in the beginning of the Guide.
            HealthIT.gov Detailed worksheets with the rationale for, and examples
            of how to implement each recommended practices follows the checklist
            section of the Guide. These worksheets include likely sources of
            information that your practice may reference to complete your
            assessment of a recommended practice, as well as fillable note fields
            to record follow-up actions. Additional guidance on completing the
            self-assessment is available on the SAFER Guides | HealthIT.gov
          </ng-container>
        </div>
      </div>
      <div class="answer-section">
        <mat-radio-group [(ngModel)]="saferGuides">
          <mat-radio-button value="yes">Yes</mat-radio-button>
          <mat-radio-button value="no">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-button (click)="cancel()">CANCEL</button>
    <button
      mat-raised-button
      color="primary"
      (click)="save()"
      [disabled]="!canSave"
    >
      SAVE ATTESTATIONS
    </button>
  </div>
</div>
